import KwiffSettings from '@/modules/integrations/types/kwiff/KwiffSettings'
import KwiffOverview from '@/modules/integrations/types/kwiff/KwiffOverview'
import KwiffPromotions from '@/modules/integrations/types/kwiff/KwiffPromotions'

export default Object.freeze({
  type: 'Kwiff',
  title: 'Integrations_Kwiff',
  category: 'Integrations_Kwiff_Category',
  description: 'Integrations_Kwiff_Description',
  image: require('@/img/integrations/promotion.png'),
  requiresAdmin: false,
  components: {
    settings: KwiffSettings,
    overview: KwiffOverview,
    promotions: KwiffPromotions
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/third-party-integrations'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/kwiff/index.js